<div class="callbacks-page">
  <div class="callbacks-toast" *ngIf="toast">
    <span class="material-icons">check_circle</span>{{ toast }}
  </div>

  <div class="callbacks-header">
    <div>
      <div class="eyebrow">Supervisor</div>
      <h1>Callback Worklist</h1>
    </div>
    <button type="button" class="icon-btn" (click)="load()" title="Refresh">
      <span class="material-icons">refresh</span>
    </button>
  </div>

  <div class="summary-grid">
    <div class="summary-card">
      <span class="material-icons">pending_actions</span>
      <div>
        <strong>{{ openCount }}</strong>
        <small>Open callbacks</small>
      </div>
    </div>
    <div class="summary-card summary-alert">
      <span class="material-icons">schedule</span>
      <div>
        <strong>{{ overdueCount }}</strong>
        <small>Overdue callbacks</small>
      </div>
    </div>
  </div>

  <div class="filter-row">
    <button type="button" [class.active]="statusFilter === 'ALL'" (click)="setStatusFilter('ALL')">All</button>
    <button type="button" [class.active]="statusFilter === 'PENDING'" (click)="setStatusFilter('PENDING')">Pending</button>
    <button type="button" [class.active]="statusFilter === 'SCHEDULED'" (click)="setStatusFilter('SCHEDULED')">Scheduled</button>
    <button type="button" [class.active]="statusFilter === 'COMPLETED'" (click)="setStatusFilter('COMPLETED')">Completed</button>
  </div>

  <div class="callback-list">
    <div class="empty-state" *ngIf="!callbacks.length">
      <span class="material-icons">event_available</span>
      <strong>No callbacks found</strong>
      <small>Saved callback requests will appear here.</small>
    </div>

    <div class="callback-row" *ngFor="let call of callbacks" [class.overdue]="call.overdueSeconds > 0">
      <div class="caller-cell">
        <div class="caller-number">{{ call.callerNumber || 'Unknown caller' }}</div>
        <div class="caller-meta">
          {{ call.hostSystem || 'Telephony' }}
          <span *ngIf="call.businessRecordType">/ {{ call.businessRecordType }}</span>
          <span *ngIf="call.businessRecordId"> #{{ call.businessRecordId }}</span>
        </div>
      </div>

      <div class="detail-cell">
        <span class="reason">{{ call.callReason || 'No reason captured' }}</span>
        <span class="notes" [title]="call.wrapUpNotes">{{ call.wrapUpNotes || call.disposition || '-' }}</span>
      </div>

      <div class="due-cell">
        <span class="due-time">{{ dueLabel(call) }}</span>
        <span class="due-alert" *ngIf="call.overdueSeconds > 0">
          Overdue {{ formatDuration(call.overdueSeconds) }}
        </span>
      </div>

      <div class="agent-cell">
        <span>{{ call.agentName || call.agentExtension || '-' }}</span>
        <small>{{ call.sourceOfInformation || 'Source not set' }}</small>
      </div>

      <div class="status-cell">
        <span class="status-pill" [ngClass]="statusClass(call.callbackStatus)">
          {{ call.callbackStatus || 'PENDING' }}
        </span>
      </div>

      <div class="actions-cell">
        <button type="button" (click)="mark(call, 'SCHEDULED')" [disabled]="call.callbackStatus === 'SCHEDULED'">
          Schedule
        </button>
        <button type="button" class="done-btn" (click)="mark(call, 'COMPLETED')" [disabled]="call.callbackStatus === 'COMPLETED'">
          Complete
        </button>
      </div>
    </div>
  </div>
</div>
